import { SkuServerError } from './types';

const cardFieldPaths: Record<string, string> = {
  skus: 'skuId',
  skuid: 'skuId',
  name: 'name',
  unitofmeasure: 'amountOfProductInSku',
  amountofproductinsku: 'amountOfProductInSku',
  grossweight: 'grossWeight',
  grossweightunitofmeasure: 'grossWeight',
  dimensions: 'dimensions.length',
  barcode: 'barcode',
  description: 'description',
};

const productFieldPaths: Record<string, string> = {
  productid: 'productId',
  productname: 'productName',
  productnetvolumeunitofmeasure: 'productNetVolumeUnitOfMeasure',
};

const normaliseFieldName = (field?: string | null): string =>
  (field ?? '')
    .toLowerCase()
    .replace(/^request\./, '')
    .replace(/^sku\./, '')
    .replace(/^skus\.\d+\./, '');

export const mapServerErrorToFormPath = (
  error: SkuServerError
): string | null => {
  const key = normaliseFieldName(error.field);
  if (productFieldPaths[key]) return productFieldPaths[key];
  const hasCardIndex =
    typeof error.skuIndex === 'number' && error.skuIndex >= 0;
  if (hasCardIndex && cardFieldPaths[key]) {
    return `skus.${error.skuIndex}.${cardFieldPaths[key]}`;
  }
  return null;
};

export const describeServerError = (error: SkuServerError): string =>
  typeof error.skuIndex === 'number' && error.skuIndex >= 0
    ? `SKU ${error.skuIndex + 1}: ${error.message}`
    : error.message;
